import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';

@Injectable({
  providedIn: 'root',
})
export class OperationService {
  constructor(
    private api: ApiService,
    private util: UtilService,
    private http: HttpClient
  ) {}

  getStakeholders(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.OPERATIONS.GET_STAKEHOLDERS, postData );
  }

  getCourseGroups(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.COURSE_GROUPS, postData );
  }

  getCourseSubGroups(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.COURSE_SUBGROUPS, postData );
  }

  getCourses(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.COURSES_BY_IDS, postData );
  }

  getCoursesVersion(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.COURSESVERSION_BY_IDS, postData );
  }

  getCourseConstituents(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.COURSECONSTITUENTS_BY_IDS, postData );
  }

  getAssessmentAnalysis(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.ASSESSMENT_ANALYSIS, postData );
  }

  getCandidateAnalysis(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ANALYSIS.CANDIDATE_ANALYSIS, postData );
  }

}
